export default __webpack_public_path__ + "static/media/Archpriest's Bracers of the Black Thread.cf2b519e.jpg";